<template>
  <div id="movelist-container" >
    <p v-if="eighty == -3 && resultsData.length == 0">{{ t("Just Play & Opponent Moves will come from game collection - weighted by popularity") }}</p>
    <p  v-else-if="eighty == -2" class="movelist-text-center">Retrieving Moves...</p>
    <p v-else-if="eighty == -1">No Moves Available</p>
    <div v-else v-for="item in resultsData" v-bind:key="item.san + item.white + item.black + item.draw + item.score + item.total + item.email">
      <div class="movelist-row" v-bind:class="hoverClassObject">

        <!-- checkbox for repertoire builder or master game list -->
        <div v-if="showCheckboxes != 'no'" class="movelist-text movelist-text-left">
          <div v-if="showCheckboxes == 'yes'">
            <input class="movelist-checkbox" type="checkbox" value="" 
                  @change="onCheckboxChange($event,item.index)"
                  v-model="item.repflagged">
          </div>
        </div>

        <!-- SAN -->
        <div class="movelist-text movelist-text-left" 
                :class="{ 'movelist-italic' : item.showItalic }" @click="onClickMove(item.index)">
                {{ (item.san == "total") ? t("total") : item.san }}
        </div>
        
        <!-- game count total -->
        <div class="movelist-text movelist-text-right" 
                :class="{ 'movelist-italic' : item.showItalic }"
                @click="onClickMove(item.index)">{{ item.total }}
        </div>
      

        <!-- Win/Loss Bar -->
        <div :class="{  'movelist-bar-with-compare' : showCompare,
                        'movelist-bar' : showCheckboxes == 'no' && !showEmails && !showCompare, 
                        'movelist-bar-with-checks-email' : 
                                showCheckboxes != 'no' && showEmails && !showCompare,
                        'movelist-bar-with-checks' : 
                                      (showCheckboxes != 'no' && !showEmails && !showCompare) ||
                                (showCheckboxes == 'no' && showEmails && !showCompare),
                      }" 
                      @click="onClickMove(item.index)">
          <div>
          <div v-show="item.white != '0' || item.black != '0' || item.draw != '0' ">
            <WinLossBar :white="item.white"  :draw="item.draw" :black="item.black" />
          </div>
          </div>
        </div>
       
        <!-- compare game count total -->
        <div v-show="showCompare" class="movelist-text movelist-text-right" 
                    :class="{ 'movelist-italic' : item.showItalic }"
                    @click="onClickMove(item.index)">
                {{ item.totalCompare }}
        </div>

        <!-- Win/Loss Bar -->
        <div v-show="showCompare" :class="{  'movelist-bar-with-compare' : showCompare,
                      'movelist-bar' : showCheckboxes == 'no' && !showEmails && !showCompare, 
                      'movelist-bar-with-checks-email' : 
                              showCheckboxes != 'no' && showEmails && !showCompare,
                      'movelist-bar-with-checks' : 
                                    (showCheckboxes != 'no' && !showEmails && !showCompare) ||
                              (showCheckboxes == 'no' && showEmails && !showCompare),
                    }" 
                    @click="onClickMove(item.index)">
          <div v-show="item.whiteCompare != '0' || item.blackCompare != '0' || item.drawCompare != '0' ">
            <WinLossBar :white="item.whiteCompare"  :draw="item.drawCompare" :black="item.blackCompare" />
          </div>
        </div>
      

        <!-- stockfish engine score -->
        <div v-show="showScores" class="movelist-text movelist-text-right" 
                        :class="{ 'movelist-italic' : item.showItalic }"
                        @click="onClickMove(item.index)">
          {{ item.score }}
        </div>

        <!-- move email for master games -->
        <div v-show="showEmails" class="movelist-text movelist-text-right" @click="onClickMove(item.index)">{{ item.email ? "Email" : "" }}</div>

      </div>
      
      <hr v-if="item.index == eighty" class="movelist-eighty-line">
    </div>
  </div>
  <!-- add 0px height invisible element. have program scroll down it to -->
  <div id="bottom-element" class="invisible-bottom-element"></div>
</template>


<script setup>

import { t } from '@/composables/translateText.js'

import WinLossBar from './WinLossBar.vue'
import { computed } from "@vue/reactivity"
import { ref , onBeforeUpdate } from 'vue'
import { watch } from "vue";
import { useConnectionStore } from '@/stores/connectionStore';

const props = defineProps({
  resultsData : Array,
  eighty : {
    type : Number,
    default : -100
  },
  isClickable : {
    type : Boolean,
    default : true
  },
  scrollToBottomTrigger : {
    type : Boolean,
    default : false
  },
  showScores : {
    type : Boolean,
    default : true
  },
  singleSelection : {
    type : Boolean,
    default : false
  },
  showCheckboxes : {
    type : String,
    default : "no"
  },
  showEmails : {
    type : Boolean,
    default : false
  },
  showCompare : {
    type : Boolean,
    default : false
  },
})

const emit = defineEmits(['movelist-click','checkbox-click'])

const connectionStore = useConnectionStore()

const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light") 

const hoverClassObject = (isDark.value) ? "dark-hover-mode" : "light-hover-mode"

const showCompare1 = ref(false)
//console.log("******************* ShowCHeck in setup")

const showScores = computed({
    get() {
      return props.showScores
    },
    set(value) {
      //emit('subscribe:user', value)
    }
  })

  const showCheckboxes = computed({
    get() {
      return props.showCheckboxes
    }
  })

  const showEmails = computed({
    get() {
      return props.showEmails
    }
  })

  const showCompare = computed({
    get() {
      return props.showCompare
    }
  })

const scrollToBottomTrigger = computed({
    get() {
      return props.scrollToBottomTrigger
    },
    set(value) {
      //emit('subscribe:user', value)
    }
  })

// https://www.delftstack.com/howto/javascript/javascript-scroll-to-bottom-of-div/
watch(scrollToBottomTrigger, (newVal,oldVal) => {
  const bottom_element = document.getElementById('bottom-element');
  bottom_element.scrollIntoView({ behavior: "smooth" })
	//scroll_to_bottom.scrollTop = scroll_to_bottom.scrollHeight ;
  //console.log("*********************************** change",scroll_to_bottom.scrollHeight)
})

function onClickMove (index) {
  //console.log("**** on move click",index)
  if (props.isClickable)
    emit("movelist-click",index)
}

function onCheckboxChange(event,index) {
  //console.log("***** on checkbox change", index)
  //console.log(" click item ",props.resultsData[index])
  //console.log(" click flag ",props.resultsData[index].repflagged)

  // if only allow single selection, then zap all the other flags in case one was selected
  if (props.singleSelection && props.resultsData[index].repflagged) {
    for (var i = 0; i < props.resultsData.length; i++)
      if (i != index)
        props.resultsData[i].repflagged = false
  }

  emit("checkbox-click",{index : index, flag : props.resultsData[index].repflagged})
}

onBeforeUpdate(() => {

})

</script>

<style scoped>

.invisible-bottom-element {
  visibility : hidden;
  height : 0px;
}

#movelist-container {
  overflow-y: scroll;
}

.movelist-row {
  line-height: 1.5em;
  /*border-bottom: #d3dfe1 solid 1px;*/
  /*border-bottom: #286a6c solid 1px;*/
}

/* https://stackoverflow.com/questions/46551925/vuejs-v-bindstyle-hover */

.light-hover-mode {
  border-bottom: #d3dfe1 solid 1px;
}
.light-hover-mode:hover {
  background: #d3dfe1;
}

.dark-hover-mode {
  border-bottom: #286a6c solid 1px;
}

.dark-hover-mode:hover {
  background: #286a6c ;
}

.movelist-text {
  display: inline-block;
  width : 10%;
  bottom : 3px;
  position : relative;
}
.movelist-text-right {
  text-align: right;
}

.movelist-italic {
  font-style: italic;
}

.movelist-text-center {
  text-align: center;
}

.movelist-text-left {
  text-align: left;
}
.movelist-bar {
  display: inline-block;
  width : 70%;
}

.movelist-bar-with-compare {
  display: inline-block;
  width : 30%;
}

.movelist-bar-with-checks {
  display: inline-block;
  width : 60%;
}

.movelist-bar-with-checks-email {
  display: inline-block;
  width : 50%;
}

.movelist-eighty-line {
  height : 5px;
  background : rgb(13,110,253)
}

.movelist-checkbox {
    border-radius: 0.25em;
}

.movelist-checkbox:checked {
    background-color: #0d6efd;
    border-color: #0d6efd;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/%3E%3C/svg%3E");
}

.movelist-checkmark-dark {
  color : white;
}

.movelist-checkmark-light {
  color : dark;
}
</style>
